import { render, staticRenderFns } from "./classify-two.vue?vue&type=template&id=0e9318c4&scoped=true&"
import script from "./classify-two.vue?vue&type=script&lang=js&"
export * from "./classify-two.vue?vue&type=script&lang=js&"
import style0 from "./classify-two.vue?vue&type=style&index=0&id=0e9318c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9318c4",
  null
  
)

export default component.exports